<div class="container">
  <nz-row
    *ngIf="!isMobile"
    class="row w-100 section-title mb-2 ms-1 d-flex justify-content-end align-items-center">
    <app-user-select
      class="justify-content-end d-flex desktop-user-select w-100"
      (chosenUser)="getUserSelect($event)"
      [hidden]="false"
      [role]="userRole"
      [user]="chosenUser != null ? chosenUser : ''"></app-user-select>
  </nz-row>

  <nz-row class="w-100">
    <nz-col nzSpan="24">
      <div class="py-2 my-1 d-flex justify-content-end">
        <button
          nz-button
          class="main-btn button-switch"
          (click)="onSwitchToggle()">
          {{ switchValue ? 'Passa a Fatturazione' : 'Passa a Scrum' }}
        </button>
      </div>
    </nz-col>
  </nz-row>

  <nz-table
    *ngIf="timeSheets; else noTimesheet"
    #timeSheetTable
    [nzScroll]="
      isMobile || isTablet ? { x: '1150px', y: '240px' } : { x: '', y: '' }
    "
    [nzData]="timeSheets"
    [nzShowPagination]="false"
    [nzPageSize]="timeSheets.length">
    <thead>
      <tr>
        <th
          id="header"
          [nzLeft]="isMobile || isTablet"
          class="d-flex align-items-center justify-content-between light-blue-background px-2"
          [nzWidth]="isTablet ? '250px' : isMobile ? '210px' : ''">
          <button
            *ngIf="!isMobile"
            nz-button
            class="transparent-btn arrow"
            (click)="previousWeek()"
            nz-tooltip="Vai alla settimana precedente">
            <img
              src="assets/images/Shared/arrow-left.svg"
              alt="back"
              height="30px" />
          </button>

          <div class="w-100 h-100">
            <nz-date-picker
              [(ngModel)]="selectedDate"
              (ngModelChange)="onDateChange($event)"
              nzFormat="dd-MM-yyyy"
              nzMode="week"
              [nzAllowClear]="false"
              class="w-100 h-100 pe-xl-3"
              [nzDisabledDate]="disableFutureDates"
              [nzShowToday]="false">
            </nz-date-picker>
          </div>

          <button
            *ngIf="!isMobile"
            nz-button
            class="transparent-btn arrow"
            [ngClass]="{ 'disabled-btn': isNextWeekDisabled() }"
            (click)="nextWeek()"
            [disabled]="isNextWeekDisabled()"
            [nz-tooltip]="
              !isNextWeekDisabled() ? 'Vai alla settimana successiva' : ''
            ">
            <img
              src="assets/images/Shared/arrow-right.svg"
              alt="back"
              height="30px" />
          </button>
        </th>
        <th
          nzWidth="190px"
          id=""
          class="text-center"
          [ngClass]="{
            'light-blue-background': !listOfColumns[0]?.is_today,
            'today-column': listOfColumns[0]?.is_today
          }">
          Lunedì {{ listOfColumns[0]?.date | date: 'dd' }}
          <img
            *ngIf="!chosenUser && listOfColumns[0]?.can_request"
            src="assets/images/Shared/manage_history.svg"
            nz-tooltip="Crea richiesta ore"
            alt="Richiedi cambio di ore"
            class="ps-3 cursor-pointer icon"
            (click)="openModal(timeSheets, listOfColumns[0]?.date)"
            onkeydown="" />
          <img
            *ngIf="chosenUser && listOfColumns[0]?.status == 'in_attesa'"
            src="assets/images/Shared/bell.svg"
            alt="confirm"
            class="ps-3 cursor-pointer icon icon-bell"
            nz-tooltip="Mostra richiesta"
            (click)="
              openModal(
                timeSheets,
                listOfColumns[0]?.date,
                timeSheets[0]?.days[0]?.note,
                'request'
              )
            "
            onkeydown="openModal(timeSheets, listOfColumns[0]?.date, timeSheets[0]?.days[0]?.note), 'request'" />
        </th>
        <th
          nzWidth="190px"
          id=""
          class="text-center"
          [ngClass]="{
            'light-blue-background': !listOfColumns[1]?.is_today,
            'today-column': listOfColumns[1]?.is_today
          }">
          Martedì {{ listOfColumns[1]?.date | date: 'dd' }}
          <img
            *ngIf="!chosenUser && listOfColumns[1]?.can_request"
            src="assets/images/Shared/manage_history.svg"
            nz-tooltip="Crea richiesta ore"
            alt="Richiedi cambio di ore"
            class="ps-3 cursor-pointer icon"
            (click)="openModal(timeSheets, listOfColumns[1]?.date)"
            onkeydown="" />
          <img
            *ngIf="chosenUser && listOfColumns[1]?.status == 'in_attesa'"
            src="assets/images/Shared/bell.svg"
            alt="confirm"
            class="ps-3 cursor-pointer icon icon-bell"
            nz-tooltip="Mostra richiesta"
            (click)="
              openModal(
                timeSheets,
                listOfColumns[1]?.date,
                timeSheets[0]?.days[1]?.note,
                'request'
              )
            "
            onkeydown="openModal(timeSheets, listOfColumns[1]?.date, timeSheets[0]?.days[1]?.note), 'request'" />
        </th>
        <th
          nzWidth="190px"
          id=""
          class="text-center"
          [ngClass]="{
            'light-blue-background': !listOfColumns[2]?.is_today,
            'today-column': listOfColumns[2]?.is_today
          }">
          Mercoledì {{ listOfColumns[2]?.date | date: 'dd' }}
          <img
            *ngIf="!chosenUser && listOfColumns[2]?.can_request"
            src="assets/images/Shared/manage_history.svg"
            nz-tooltip="Crea richiesta ore"
            alt="Richiedi cambio di ore"
            class="ps-3 cursor-pointer icon"
            (click)="openModal(timeSheets, listOfColumns[2]?.date)"
            onkeydown="" />
          <img
            *ngIf="chosenUser && listOfColumns[2]?.status == 'in_attesa'"
            src="assets/images/Shared/bell.svg"
            alt="confirm"
            class="ps-3 cursor-pointer icon icon-bell"
            nz-tooltip="Mostra richiesta"
            (click)="
              openModal(
                timeSheets,
                listOfColumns[2]?.date,
                timeSheets[0]?.days[2]?.note,
                'request'
              )
            "
            onkeydown="openModal(timeSheets, listOfColumns[2]?.date, timeSheets[0]?.days[2]?.note), 'request'" />
        </th>
        <th
          nzWidth="190px"
          id=""
          class="text-center"
          [ngClass]="{
            'light-blue-background': !listOfColumns[3]?.is_today,
            'today-column': listOfColumns[3]?.is_today
          }">
          Giovedì {{ listOfColumns[3]?.date | date: 'dd' }}
          <img
            *ngIf="!chosenUser && listOfColumns[3]?.can_request"
            src="assets/images/Shared/manage_history.svg"
            nz-tooltip="Crea richiesta ore"
            alt="Richiedi cambio di ore"
            class="ps-3 cursor-pointer icon"
            (click)="openModal(timeSheets, listOfColumns[3]?.date)"
            onkeydown="" />
          <img
            *ngIf="chosenUser && listOfColumns[3]?.status == 'in_attesa'"
            src="assets/images/Shared/bell.svg"
            alt="confirm"
            class="ps-3 cursor-pointer icon icon-bell"
            nz-tooltip="Mostra richiesta"
            (click)="
              openModal(
                timeSheets,
                listOfColumns[3]?.date,
                timeSheets[0]?.days[3]?.note,
                'request'
              )
            "
            onkeydown="openModal(timeSheets, listOfColumns[3]?.date, timeSheets[0]?.days[3]?.note), 'request'" />
        </th>
        <th
          nzWidth="190px"
          id=""
          class="text-center"
          [ngClass]="{
            'light-blue-background': !listOfColumns[4]?.is_today,
            'today-column': listOfColumns[4]?.is_today
          }">
          Venerdì {{ listOfColumns[4]?.date | date: 'dd' }}
          <img
            *ngIf="!chosenUser && listOfColumns[4]?.can_request"
            src="assets/images/Shared/manage_history.svg"
            nz-tooltip="Crea richiesta ore"
            alt="Richiedi cambio di ore"
            class="ps-3 cursor-pointer icon"
            (click)="openModal(timeSheets, listOfColumns[4]?.date)"
            onkeydown="" />
          <img
            *ngIf="chosenUser && listOfColumns[4]?.status == 'in_attesa'"
            src="assets/images/Shared/bell.svg"
            alt="confirm"
            class="ps-3 cursor-pointer icon icon-bell"
            nz-tooltip="Mostra richiesta"
            (click)="
              openModal(
                timeSheets,
                listOfColumns[4]?.date,
                timeSheets[0]?.days[4]?.note,
                'request'
              )
            "
            onkeydown="openModal(timeSheets, listOfColumns[4]?.date, timeSheets[0]?.days[4]?.note), 'request'" />
        </th>
      </tr>
    </thead>

    <tbody>
      <!-- Row tabella -->
      <tr *ngFor="let project of timeSheetTable.data; let i = index">
        <!-- Col tabella -->
        <th
          id=""
          [nzLeft]="isMobile || isTablet"
          class="light-blue-background column-radius p-3">
          <nz-row [nzGutter]="24" nzAlign="middle">
            <!-- Immagine progetto -->
            <nz-col
              [nzLg]="{ span: 4, offset: 0 }"
              [nzMd]="{ span: 4, offset: 0 }"
              [nzSm]="{ span: 4, offset: 0 }"
              [ngClass]="isMobile ? 'pe-0' : ''">
              <img
                [src]="this.utilityService.getSanitizeUrl(project.path)"
                alt=""
                class="icon-project"
                [ngClass]="
                  project?.status == 'In corso' ? 'in-progress' : 'maintenance'
                " />
            </nz-col>

            <!-- Nome progetto -->
            <nz-col
              [nzLg]="{ span: 20, offset: 0 }"
              [nzMd]="{ span: 20, offset: 0 }"
              [nzSm]="{ span: 20, offset: 0 }"
              [ngClass]="isMobile ? 'pe-0' : ''">
              <p class="mb-0">{{ project.alias }}</p>
            </nz-col>
          </nz-row>
        </th>
        <th
          id=""
          *ngFor="let day of project?.days; let j = index"
          class="p-3"
          [ngClass]="{ 'opacity-50': !day.time }">
          <nz-row
            [nzGutter]="24"
            class="py-2 bg-gray"
            [ngClass]="{
              'border-pending': day?.status == 'in_attesa'
            }"
            [nz-tooltip]="
              day?.status == 'in_attesa'
                ? 'In attesa di conferma ore'
                : !day.time
                  ? 'Nessuna sprint in corso per questo giorno'
                  : ''
            ">
            <nz-col
              [nzLg]="{ span: 16, offset: 0 }"
              [nzMd]="{ span: 16, offset: 0 }"
              [nzSm]="{ span: 16, offset: 0 }">
              <!-- Time picker -->
              <!-- SE VOGLIAMO INSERIRE IL LIMITE GIORNALIERO DI ORE INSERIRE QUESTI TAG DEL TIME PICKER E DECOMMENTARE LE FUNZIONI NEL TS -->
              <!--
                [nzDisabledHours]="getDisabledHoursForDay(day)"
                [nzDisabledMinutes]="getDisabledMinutes"
              -->
              <nz-time-picker
                [disabled]="!day.time || !day.is_authorized"
                [(ngModel)]="day.time"
                [nzDisabledHours]="disabledHours"
                [nzDisabledMinutes]="disabledMinutes"
                (nzOpenChange)="onTimePickerOpenChange($event, day)"
                (ngModelChange)="
                  changeTime(
                    $event,
                    project.id,
                    chosenUser ? chosenUser : profileData.id,
                    day.date,
                    type,
                    i,
                    j
                  )
                "
                [nzMinuteStep]="15"
                nzFormat="HH:mm"
                nzPlaceHolder="Tempo"
                [nzNowText]="' '"
                [nzOkText]="'Salva'"
                [nzAllowEmpty]="false"></nz-time-picker>
            </nz-col>

            <!-- Note -->
            <nz-col
              [nzLg]="{ span: 8, offset: 0 }"
              [nzMd]="{ span: 8, offset: 0 }"
              [nzSm]="{ span: 8, offset: 0 }"
              [ngClass]="isMobile ? 'p-0' : ''">
              <button
                nz-button
                [disabled]="!day.time"
                class="transparent-btn"
                (click)="openNoteModal(day, project.id, i, j)">
                <nz-badge [nzCount]="day.note ? 1 : 0" nzSize="small">
                  <img src="assets/images/Shared/note.svg" alt="note" />
                </nz-badge>
              </button>
            </nz-col>
          </nz-row>
        </th>
      </tr>
      <tr>
        <th
          id=""
          *ngIf="timeSheets.length > 0"
          [nzLeft]="isMobile || isTablet"
          class="light-blue-background column-radius p-3">
          <nz-row nzAlign="middle" [nzGutter]="24">
            <nz-col
              [nzLg]="{ span: 20, offset: 4 }"
              [nzMd]="{ span: 20, offset: 4 }"
              [nzSm]="{ span: 20, offset: 4 }">
              <p class="mb-0">Totale</p>
            </nz-col>
          </nz-row>
        </th>
        <ng-container *ngIf="timeSheets.length > 0">
          <th
            *ngFor="let day of totalTimeSheet?.days; let i = index"
            class="p-1">
            <nz-row>
              <nz-col nzSpan="24" class="total-cell">
                <p class="mb-0">{{ day.time }}</p>
                <img
                  *ngIf="day.time > '08:00'"
                  src="assets/images/Shared/alert.svg"
                  alt="alert"
                  nz-tooltip="L'utente ha superato le ore 8 giornaliere" />
              </nz-col>
            </nz-row>
          </th>
        </ng-container>
      </tr>
    </tbody>
  </nz-table>
  <ng-template #noTimesheet>
    <div class="mt-5">
      <h6 class="text-center">Nessun timesheet disponibile</h6>
    </div>
  </ng-template>
</div>

<!-- Modale note -->
<nz-modal [(nzVisible)]="isModalOpen" [nzClosable]="false">
  <ng-container *nzModalTitle="">
    <h5 class="mb-0 title-note">Note</h5>
  </ng-container>
  <ng-container *nzModalContent>
    <textarea
      nz-input
      [(ngModel)]="this.note"
      [readOnly]="chosenUser"
      placeholder="Scrivi la tua nota"
      [nzAutosize]="{ minRows: 6, maxRows: 6 }"></textarea>
  </ng-container>
  <ng-container *nzModalFooter>
    <button nz-button class="main-close-btn" (click)="closeModal()">
      Annulla
    </button>
    <button *ngIf="!chosenUser" nz-button class="main-btn" (click)="saveNote()">
      Salva
    </button>
  </ng-container>
</nz-modal>

<!-- Modale per richiedere cambio ore di Scrum e di Fatturazione -->
<nz-modal
  [(nzVisible)]="isModalRequired"
  [nzClosable]="false"
  [nzCentered]="true"
  [nzMaskClosable]="false"
  [nzAutofocus]="null"
  nzWidth="600px"
  class="main-font">
  <ng-container *nzModalTitle="">
    <h5 class="mb-0 title-note">Richiesta cambio ore</h5>
  </ng-container>

  <ng-container *nzModalContent>
    <div
      class="modal-content"
      *ngIf="projectsControl.length > 0; else noProjects">
      <form nz-form *ngIf="timeSheetForm" [formGroup]="timeSheetForm">
        <div class="d-flex">
          <p class="mb-0 me-2">Data</p>
          <p class="mb-0 fw-bold">
            {{ selectedDateHeader | date: 'dd-MM-yyyy' }}
          </p>
        </div>

        <!-- Tabella -->
        <nz-row class="header-section light-blue-background w-100 p-2 mt-3">
          <nz-col [nzSpan]="8" class="text-bolder">Progetti</nz-col>
          <nz-col [nzSpan]="7" class="text-bolder text-center">
            Ore fatturazione
          </nz-col>
          <nz-col [nzSpan]="7" class="text-bolder text-center">
            Ore scrum
          </nz-col>
          <nz-col [nzSpan]="2"></nz-col>
        </nz-row>

        <div formArrayName="projects">
          <nz-row
            *ngFor="
              let project of projectsControl;
              let i = index;
              let last = last
            "
            [formGroupName]="i"
            class="">
            <ng-container
              *ngIf="getDayForProject(timeSheetsModal[i]) as selectedDay">
              <nz-col
                [nzSpan]="8"
                class="light-blue-background d-flex align-items-center ps-2">
                <img
                  [src]="
                    this.utilityService.getSanitizeUrl(timeSheetsModal[i].path)
                  "
                  [alt]="timeSheetsModal[i].alias"
                  class="icon-project me-1"
                  [ngClass]="
                    timeSheetsModal[i]?.status == 'In corso'
                      ? 'in-progress'
                      : 'maintenance'
                  " />
                <p class="mb-0 prova">{{ timeSheetsModal[i].alias }}</p>
                <p
                  class="text-danger mb-0"
                  *ngIf="
                    (project.value.is_authorized &&
                      selectedDay?.status == 'in_attesa') ||
                    (project.value.is_authorized && !chosenUser)
                  ">
                  *
                </p>
              </nz-col>

              <nz-col [nzSpan]="7" class="d-flex justify-content-center p-2">
                <nz-time-picker
                  [ngClass]="{
                    'border-pending': selectedDay?.status == 'in_attesa'
                  }"
                  [nz-tooltip]="
                    selectedDay?.status == 'in_attesa'
                      ? 'In attesa di conferma ore'
                      : !selectedDay.time
                        ? 'Nessuna sprint in corso per questo giorno'
                        : ''
                  "
                  formControlName="billing_value"
                  [nzDisabled]="
                    isReadOnly ||
                    isBillingValueDisabled(project) ||
                    project.value.is_authorized
                  "
                  [nzMinuteStep]="15"
                  [nzDisabledHours]="disabledHours"
                  [nzDisabledMinutes]="disabledMinutes"
                  nzFormat="HH:mm"
                  nzPlaceHolder="Tempo"
                  [nzNowText]="' '"
                  [nzAllowEmpty]="false"
                  [nzOkText]="'Salva'"></nz-time-picker>
              </nz-col>

              <nz-col [nzSpan]="7" class="d-flex justify-content-center p-2">
                <nz-time-picker
                  [ngClass]="{
                    'border-pending': selectedDay?.status == 'in_attesa'
                  }"
                  [nz-tooltip]="
                    selectedDay?.status == 'in_attesa'
                      ? 'In attesa di conferma ore'
                      : !selectedDay.time
                        ? 'Nessuna sprint in corso per questo giorno'
                        : ''
                  "
                  formControlName="value"
                  [nzDisabled]="
                    isReadOnly ||
                    isValueDisabled(project) ||
                    project.value.is_authorized
                  "
                  [nzMinuteStep]="15"
                  [nzDisabledHours]="disabledHours"
                  [nzDisabledMinutes]="disabledMinutes"
                  nzFormat="HH:mm"
                  nzPlaceHolder="Tempo"
                  [nzNowText]="' '"
                  [nzAllowEmpty]="false"
                  [nzOkText]="'Salva'"></nz-time-picker>
              </nz-col>
              <nz-col
                [nzSpan]="2"
                class="d-flex justify-content-start align-items-center">
                <div
                  *ngIf="
                    projectsControl[i].hasError('valueGreaterThanBilling')
                  ">
                  <img
                    src="assets/images/Shared/alert.svg"
                    alt="alert"
                    nz-tooltip="Le ore Scrum non possono superare quelle di fatturazione." />
                </div>
              </nz-col>
            </ng-container>
          </nz-row>
        </div>

        <!-- Totale -->
        <nz-row *ngIf="selectedTotal">
          <nz-col
            [nzSpan]="8"
            class="d-flex align-items-center light-blue-background border-bottom-radius ps-2">
            Totale
          </nz-col>

          <nz-col
            [nzSpan]="7"
            class="d-flex justify-content-center align-items-center">
            <div
              class="total-cell total-cell-modal p-2 d-flex justify-content-center align-items-center">
              <p class="mb-0 fw-bold">{{ selectedTotal.billing_value }}</p>
              <img
                *ngIf="selectedTotal.billing_value > '08:00'"
                src="assets/images/Shared/alert.svg"
                alt="alert"
                nz-tooltip="L'utente ha superato le ore 8 giornaliere" />
            </div>
          </nz-col>

          <nz-col [nzSpan]="7" class="d-flex justify-content-center">
            <div
              class="total-cell total-cell-modal p-2 d-flex justify-content-center align-items-center">
              <p class="mb-0 fw-bold">{{ selectedTotal.value }}</p>
              <img
                *ngIf="selectedTotal.value > '08:00'"
                src="assets/images/Shared/alert.svg"
                alt="alert"
                nz-tooltip="L'utente ha superato le ore 8 giornaliere" />
            </div>
          </nz-col>
        </nz-row>

        <div
          class="text-danger w-100 mt-2"
          *ngIf="!chosenUser; else otherMessage">
          (*) Per questi progetti non è necessario una richiesta. Puoi
          modificare le ore dalla home
        </div>

        <ng-template #otherMessage>
          <div class="text-danger w-100 mt-2">
            (*) Andrai ad accettare le ore solo per questi progetti
          </div>
        </ng-template>

        <nz-form-item class="mt-3">
          <nz-form-control [nzSpan]="24">
            <nz-form-label nzFor="note" [nzNoColon]="true" class="label-text">
              Nota
            </nz-form-label>
            <textarea
              [readOnly]="isReadOnly"
              [nzAutosize]="{ minRows: 3, maxRows: 4 }"
              nz-input
              formControlName="note"
              placeholder="Inserisci la motivazione del cambio delle ore">
            </textarea>
          </nz-form-control>
        </nz-form-item>
      </form>
    </div>

    <ng-template #noProjects>
      <div class="modal-content">
        <p class="text-center text-muted p-4">
          Nessun progetto disponibile per la data selezionata.
        </p>
      </div>
    </ng-template>
  </ng-container>

  <ng-container *nzModalFooter>
    <button nz-button class="main-close-btn" (click)="closeModalRequired()">
      Annulla
    </button>
    <button
      nz-button
      class="main-btn"
      (click)="
        isReadOnly
          ? confirmRequest(chosenUser!, selectedDateHeader)
          : saveRequest()
      "
      [disabled]="
        timeSheetForm.invalid ||
        (isReadOnly ? false : timeSheetForm.pristine) ||
        hasFinishMaxHours()
      "
      [ngClass]="{
        'disabled-btn':
          !isReadOnly &&
          (timeSheetForm.invalid ||
            timeSheetForm.pristine ||
            hasFinishMaxHours()),
        'main-btn':
          isReadOnly ||
          !(
            timeSheetForm.invalid ||
            timeSheetForm.pristine ||
            hasFinishMaxHours()
          )
      }">
      {{ isReadOnly ? 'Conferma' : 'Invia' }}
    </button>
  </ng-container>
</nz-modal>
